import type { RoutePlanVisit } from '@/api/route-plans';

// A visit counts as prioritized only while its category still allows it: the stored flag
// is kept raw (so wizard round-trips survive a switched-off category) and goes inert here,
// mirroring the backend boost gate.
export function effectivePrioritized(visit: RoutePlanVisit): boolean {
  return visit.prioritized && !!visit.serviceCategoryPrioritizationEnabled;
}

// Highest category priority first (kept first by the optimizer), prioritized visits first
// within their category band, then insertion order.
export function byCategoryPriority(a: RoutePlanVisit, b: RoutePlanVisit): number {
  const priorityA = a.serviceCategoryPriority ?? -1;
  const priorityB = b.serviceCategoryPriority ?? -1;
  if (priorityA !== priorityB) return priorityB - priorityA;

  const prioritizedA = effectivePrioritized(a);
  if (prioritizedA !== effectivePrioritized(b)) return prioritizedA ? -1 : 1;

  return a.id - b.id;
}
